var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElButton',{attrs:{"type":"info","plain":""},on:{"click":_vm.emitExpandEvent}},[(!_vm.expand)?_c('span',[_vm._v(" DETAILED VIEW ")]):_c('span',[_vm._v(" SHORT VIEW ")])])}
var staticRenderFns = []

export { render, staticRenderFns }